export class SubviewHasNoUpdatePermissionError extends Error {
  constructor() {
    super('Subview has no update permission');

    this.response = {
      data: {
        errors: ['forbidden'],
      },
    };
  }
}
